import React, { Component } from "react";
import { Image } from "react-bootstrap";
import axios from "axios";
import wx from "weixin-js-sdk";
import { datahost, shkyhost, gesture, pic_host } from "../../config/Const.js";
import { replaceAllFixed } from "../../function/Basic.js";
import { createContact } from "../../function/Share.js";

import enj from "../../language/en.json";
import zhj from "../../language/zh.json";

import "bootstrap/dist/css/bootstrap.min.css";
import "../../../style/CondoNews.css";

export class NewsDetailSh extends Component {
  state = {
    lang: enj,
    sh: null,
    article: null,
  };

  componentDidMount() {
    this.initLanguage();
    this.loadPage();
  }

  render() {
    return (
      <div id="newsDetail">
        <strong>
          <div id="newsTitle" className="news-title"></div>
        </strong>
        <br />
        <br />
        <div id="newsContent"></div>
        <br />
        <br />
        <div className="agent_detsec section_margin" id="shared_contact">
          <div className="mainagent_leftsec">
            <div className="outer_agentdet_sec">
              <div className="main_agentpic_sec">
                <Image id="contact_hd" />
              </div>
              <div className="main_agentdetsec">
                <h2 id="contact_name"></h2>
                <h3 id="contact_title"></h3>
                <p id="contact_company"></p>
              </div>
            </div>
            <div className="agent_description_mainsec">
              <h5>{this.state.lang.share_introduction}</h5>
              <p id="contact_introduction"></p>
            </div>
            <div className="agentfull_detsec">
              <ul>
                <li>
                  <a id="contact_message">
                    <i className="fa fa-comments"></i>
                    <p>{this.state.lang.share_message}</p>
                  </a>
                </li>
                <li>
                  <a id="contact_phone">
                    <i className="fa fa-phone-alt"></i>
                    <p>{this.state.lang.share_phone}</p>
                  </a>
                </li>
                <li>
                  <a id="contact_email">
                    <i className="fa fa-envelope"></i>
                    <p>{this.state.lang.share_email}</p>
                  </a>
                </li>
              </ul>
            </div>
            <div className="mainqrcode_sec">
              <h2>[ {this.state.lang.share_scanqr} ]</h2>
              <img id="contact_qr" width="30%" thumbnail="true" />
            </div>
          </div>
        </div>

        <div hidden={true}>
          <p>
            <i id="wx_title"></i>
            <i id="wx_desc"></i>
            <i id="wx_imgurl"></i>
            <i id="wx_link"></i>
          </p>
        </div>

        <div class="bottom_sliding_sec">
          <div class="yiju_logosec pull-left">
            <img src={require("../../../images/yiju_logo.png")} alt="" />
            <p>
              {this.state.lang.yiju}
              {/* <i class="fa fa-angle-double-right"></i> */}
            </p>
          </div>
          <div class="detailapp_btn pull-right">
            <button
              type="button"
              class="common_mainbtn btn btn-primary"
              onClick={() => {
                this.JumpToGuide();
              }}
            >
              {this.state.lang.dtl_detailsinapp}
            </button>
          </div>
        </div>

        <div id="footer">
          <br />
          <br />
        </div>
      </div>
    );
  }

  initLanguage() {
    let language = (
      navigator.browserLanguage || navigator.language
    ).toLowerCase();
    if (language.indexOf("zh") > -1) {
      this.setState({
        lang: zhj,
      });
    }
  }

  async loadPage() {
    try {
      var url = document.location.toString();
      document.getElementById("wx_link").innerText = url;
      // be compatible with Facebook
      if (url.indexOf("&")) {
        url = url.split("&")[0];
      }
      // be compatible with WeChat
      if (url.indexOf("=")) {
        url = url.split("=")[0];
      }
      var sh = url.split("?").splice(1, 1);
      this.setState({ sh: sh });
      axios.defaults.baseURL = datahost;
      axios.defaults.headers.post["Content-Type"] = "application/json";
      let param = "\"{'sh':'" + sh + "'}\"";
      axios.post("/share/article", param).then((res) => {
        this.setState({ dtl: res.data });
        // Set contact user
        if (this.state.dtl.usr !== undefined) {
          createContact(this.state.dtl.usr);
          document.getElementById("shared_contact").hidden = false;
        } else {
          document.getElementById("shared_contact").hidden = true;
        }
        // Set article content
        var content = res.data.data.content;
        if (content !== undefined) {
          content = replaceAllFixed(
            content,
            "/aprg",
            gesture + pic_host + "/aprg"
          );
          content = replaceAllFixed(
            content,
            "/eadf26jst",
            gesture + pic_host + "/eadf26jst"
          );
          document.getElementById("newsContent").innerHTML = content;
        }
        // Set title and wx-tags
        let title = res.data.mini.title;
        document.title = title;
        document.getElementById("newsTitle").innerText = title;
        document.getElementById("wx_title").innerText =
          this.state.lang.dtl_share_title + title;
        document.getElementById("wx_desc").innerText = res.data.mini.brief;
        document.getElementById("wx_imgurl").innerText = res.data.mini.image;
        // WxShare Configuration
        axios.defaults.baseURL = shkyhost;
        axios
          .get(
            "/wx/wxconfig?url=" +
              encodeURI(document.getElementById("wx_link").innerText)
          )
          .then((resWC) => {
            wx.config({
              appId: resWC.data.appid,
              timestamp: resWC.data.timestamp,
              nonceStr: resWC.data.nonceStr,
              signature: resWC.data.signature,
              jsApiList: [
                "updateAppMessageShareData",
                "updateTimelineShareData",
              ],
            });

            wx.ready(() => {
              wx.updateAppMessageShareData({
                title: document.getElementById("wx_title").innerText,
                desc: document.getElementById("wx_desc").innerText,
                link: document.getElementById("wx_link").innerText,
                imgUrl: document.getElementById("wx_imgurl").innerText,
                success: () => {},
              });

              wx.updateTimelineShareData({
                title: document.getElementById("wx_title").innerText,
                link: document.getElementById("wx_link").innerText,
                imgUrl: document.getElementById("wx_imgurl").innerText,
                success: () => {},
              });
            });
          });
      });
    } catch {}
  }

  JumpToGuide() {
    let path = "/yiju/gdnews?" + this.state.sh;
    this.props.history.push(path);
  }
}
